const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/gestor_aps/EmptyRouterView.vue");
const GestorAps = () => /* webpackChunkName: "Home" */ import("./../views/gestor_aps/Home.vue");
const PatientManager = () => /* webpackChunkName: "PatientHome" */ import("./../views/some_hcm/patient/PatientHome.vue");
const MedicAtention = () => /* webpackChunkName: "medicAtentions" */ import("./../views/mental_health_pharmacy/medic_atention/medic_Atentions.vue");
const ApsDerivationRequestView = () => /* webpackChunkName: "medicAtentions" */ import("@/views/gestor_aps/ApsDerivationRequestView.vue");
const ContrarefVisor = () => /* webpackChunkName: "contrarefVisor" */ import("@/views/gestor_aps/ContrarefVisor.vue");

export const routes = [
  {
    path: "/manager_aps",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "gestorApsHome",
        component: GestorAps,
      },
      {
        path: "gestion-paciente",
        name: "gestorAPSsomeHcmPatientManager",
        component: PatientManager,
      },
      {
        path: "atencionMedica",
        name: "mentalHealthPharmacyMedicAtention",
        component: MedicAtention,
      },
      {
        path: "derivacionesContinuidadAtencion",
        name: "apsDerivationRequest",
        component: ApsDerivationRequestView,
      },
      {
        path: "contrarefVisor",
        name: "contrarefVisorGestorAps",
        component: ContrarefVisor,
      },
    ],
  },
];
